<template>
  <div>
    <div class="columns is-paddingless is-vcentered column is-12 has-text-grey is-size-7 is-border-bottom">
      <div class="column is-narrow is-padding-top-small is-padding-bottom-small">
        <strong class="is-size-6">Le {{flux.created_on | prettyDate}} à {{flux.created_on | prettyTime}}</strong>
      </div>
    </div>
    <div class="columns is-paddingless is-vcentered column is-12 has-text-grey has-bg-light is-size-7 is-border-bottom">
      <div class="column is-narrow is-padding-top-small is-padding-bottom-small"><strong>Programmes</strong></div>
      <div class="column is-padding-top-small is-padding-bottom-small">
        <span class="tag is-danger is-pulled-right is-xsmall">
          {{flux.program_added_number_failed + flux.program_deleted_number_failed + flux.program_updated_number_failed}} erreur(s)
        </span>
      </div>
    </div>
    <ul>
      <li class="column is-border-bottom">Ajoutés : {{flux.program_added_number}}</li>
      <li class="column is-border-bottom">Mis à jour : {{flux.program_updated_number}}</li>
      <li class="column is-border-bottom">Supprimés : {{flux.program_deleted_number}}</li>
    </ul>
    <div class="columns is-paddingless is-vcentered column is-12 has-text-grey has-bg-light is-size-7 is-border-bottom">
      <div class="column is-narrow is-padding-top-small is-padding-bottom-small"><strong>Lot</strong></div>
      <div class="column is-padding-top-small is-padding-bottom-small">
        <span class="tag is-danger is-pulled-right is-xsmall">
          {{flux.lot_added_number_failed + flux.lot_deleted_number_failed + flux.lot_updated_number_failed}} erreur(s)
        </span>
      </div>
    </div>
    <ul>
      <li class="column is-border-bottom">Ajoutés : {{flux.lot_added_number}}</li>
      <li class="column is-border-bottom">Mis à jour : {{flux.lot_updated_number}}</li>
      <li class="column is-border-bottom">Supprimés : {{flux.lot_deleted_number}}</li>
    </ul>

    <div class="columns is-paddingless is-vcentered column is-12 has-text-grey has-bg-light is-size-7 is-border-bottom">
      <div class="column is-narrow is-padding-top-small is-padding-bottom-small"><strong>Erreurs</strong></div>
      <div class="column is-padding-top-small is-padding-bottom-small" v-if="flux.reasons && flux.reasons.length && isSuperAdmin">
        <a class="tag is-draft is-small is-rounded is-pulled-right is-margin-left-small has-text-white has-text-weight-light" @click="displayErrors = !displayErrors">
          <i class="fas fa-ellipsis-h is-padding-right-xsmall"></i>Voir
        </a>
        <span class="tag is-danger is-pulled-right is-xsmall">Total : {{flux.reasons.length}} erreur(s)</span>
      </div>
    </div>
    <ul v-if="flux.reasons && flux.reasons.length && displayErrors">
      <li class="column is-border-bottom" v-for="(reason, id) in flux.reasons" :key="id">
        <div class="columns is-gapless has-text-grey is-size-6 is-multiline" >
          <div class="column">{{reason}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        displayErrors: false
      }
    },
    props: {
      source: {
        type: Object
      }
    },
    computed: {
      ...mapGetters(['isSuperAdmin']),
      flux () {
        return this.source
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/flux/FluxItem.vue